import React from 'react';
import { UsersIcon, SchoolIcon, HandHeartIcon, HomeIcon } from 'lucide-react';
const groups = [{
  icon: UsersIcon,
  title: 'Club coaches',
  body: 'Weekly sessions for juniors and adults, beginner to intermediate, without rebuilding the plan every Sunday.'
}, {
  icon: SchoolIcon,
  title: 'PE teachers',
  body: 'A badminton block that runs lesson by lesson, with stations that keep a full class hitting.'
}, {
  icon: HandHeartIcon,
  title: 'Volunteer coaches',
  body: 'Start at Session 1 and follow the ladder. Cue scripts tell you what to say and what to watch for.'
}, {
  icon: HomeIcon,
  title: 'Parents who coach',
  body: 'Simple games, simple cues and the rules on one card, so the first session feels easy.'
}];

/** Shown in the first review slot until real buyer reviews are added. */
export function WhoItsFor() {
  return <section aria-labelledby="who-heading" className="w-full bg-white" data-id="element-395" data-mp="3v3f9t864j2ma">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-396" data-mp="3v1kpnw2ofej9">
        <div className="text-center" data-id="element-397" data-mp="1zof8kpxeqcpn">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court" data-id="element-398" data-mp="1zrjkk9h46cqv">
            Who it&apos;s for
          </p>
          <h2 id="who-heading" className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-399" data-mp="1qwll0jjgo1qk">
            Built for the coach running real groups
          </h2>
        </div>
        <div className="mt-9 grid gap-3 sm:grid-cols-2" data-id="element-400" data-mp="1gx4gw6juxvwp">
          {groups.map(g => <div key={g.title} className="flex gap-4 rounded-2xl border border-line bg-white p-5 shadow-card" data-id="element-401" data-mp="1byt69tlqnhdf">
              <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-court-soft" data-id="element-402" data-mp="180n4z13o5tzw">
                <g.icon className="h-5 w-5 text-court" aria-hidden="true" data-id="element-403" data-mp="32cjzx41blhzp" />
              </span>
              <div data-id="element-404" data-mp="32a7kaxj1bjpt">
                <h3 className="font-display text-base font-bold text-ink" data-id="element-405" data-mp="2xdqnlexrrx14">{g.title}</h3>
                <p className="mt-1 text-sm text-ink-soft" data-id="element-406" data-mp="3gi3qy6lwk6ye">{g.body}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}